export default __webpack_public_path__ + "svg/calendar/2026/2/febrero.svg?1d082bde";